import { render, staticRenderFns } from "./TargetScoreDetails.vue?vue&type=template&id=36d5ebf0&scoped=true"
import script from "./TargetScoreDetails.vue?vue&type=script&lang=js"
export * from "./TargetScoreDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5ebf0",
  null
  
)

export default component.exports